import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {format} from 'one-util-date';
import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET_CERNER as PATIENTSET,
    RESET as PATIENTRESET,
    SETSELECTED_CERNER
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction, resetAction
} from 'one-state-activeallergies/src/actions';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of Active allergies
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchAllergiesCerner = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            cernerendpoints: {
                activeallergies,
                apitoken
            },
            servers,
            uisettings: {
                dashboardapiconfig: {
                    activeallergies: activeallergiesApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_CERNER),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the active allergies response
                 */
                let dataresponse: any = action.payload;
                const postAllergies = (request: any) => {
                    if (request?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "CernerID": request.id,
                        }
                        let response;
                        if (finesse_proxy_service) {
                            response = InvokeFinesseProxy(activeallergies, data, apitoken, locations, log, 'POST', alertnotification);

                        } else {
                            response = server.post({
                                headers: headers,
                                path: activeallergies,
                                data: data
                            })
                                .then((allergiesresponsefound: any) => allergiesresponsefound)
                                .catch((allergieserror: any) => {
                                    log.error(
                                        "ccw-gadget,activeallergies-cerner",
                                        "active aleergies-cerner", {
                                        allergieserror
                                    }
                                    );
                                    let errorbuild: ErrorObject = {
                                        source: "ActiveAllergies",
                                        type: "error",
                                        status: allergieserror?.status,
                                        erroritems: allergieserror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,activealergies-cerner",
                                "activealergies-cerner response", {
                                response
                            });
                        }
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!activeallergiesApi) return []
                return postAllergies(dataresponse).
                    pipe(
                        map((allergiesres: any) => TransformResponse(allergiesres, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.allergies)
                            ];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1004" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = response.error.status;
                                disp.meta04 = response.error.erroritems[0].error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "187" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller.callId;
                                }
                                disp.meta02 = dataresponse.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for Active Allergies
 * @param context  contains logger which is used for logging
 */
export const clearAllergiesCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, allergy-cerner",
            "clear-allergy-cerner", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED_CERNER, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);